<style scoped>
</style>
<template>
  <FrontEndDev />
</template>
<script route="/dev/front_end">
  import FrontEndDev from './front_end_dev'
  export default {
    components: {
      FrontEndDev
    },

  }
</script>
